import { lazy, Suspense } from 'react';
import { useAppContext } from '../context';

const MobileApp = lazy(() => import('../pages/mobile'));
const DesktopApp = lazy(() => import('../pages/desktop'));

const Preloader = () => {
    return (
        <div className="fixed inset-0 flex items-center justify-center bg-vkusvill-green">
            <div className="flex space-x-2">
                {[...Array(3)].map((_, i) => (
                    <div
                        key={i}
                        className="w-3 h-3 rounded-full bg-white animate-bounce"
                        style={{
                            animationDelay: `${i * 0.15}s`
                        }}
                    />
                ))}
            </div>
        </div>
    );
};
export const Router = () => {
    const { loading, isMobile } = useAppContext();

    if (loading) return null;

    return (
        <Suspense fallback={<Preloader />}>
            {isMobile ? <MobileApp /> : <DesktopApp />}
        </Suspense>
    );
};